<template>
  <div v-loading="loading.ruleDeliverFlowSearchById">
    <div class="header">
      <h3>流程设置</h3>
    </div>
    <list-block>
      <el-form
        ref="form"
        :rules="rules"
        :inline="true"
        :model="form"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="流程编码:" prop="ruleCode">
              <el-input v-model="form.ruleCode" :disabled="isDetail" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流程描述:" prop="description">
              <el-input v-model="form.description" :disabled="isDetail" />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="header">
          <h4>流程前置条件</h4>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单类型:" prop="orderType">
              <el-select
                v-model="form.orderType"
                placeholder="请选择订单类型"
                :disabled="isDetail"
              >
                <el-option
                  v-for="item in deliverTypeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库:" prop="warehouseCode">
              <el-select
                v-model="form.warehouseCode"
                placeholder="请选择仓库"
                :disabled="isDetail"
                filterable
                @change="handleSelect"
              >
                <el-option
                  v-for="(item, index) in warehouseList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseCode"
                />
              </el-select>
            </el-form-item>
            <el-checkbox
              v-model="form.isDefault"
              style="margin-top: -20px"
              :disabled="isDetail"
            >
              设为默认流程
            </el-checkbox>
          </el-col>
          <el-col :span="8">
            <el-form-item label="货主:" prop="shippers.infos">
              已选择<span class="special-color">{{ form.shippers.infos.length }} </span>个货主
              <el-button
                type="text"
                @click="handleEdit"
              >
                编辑
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="header">
          <h4>流程配置</h4>
        </div>
        <el-row style="margin: 10px 0;">
          <el-steps
            :space="200"
            :active="stepActive"
            finish-status="success"
          >
            <el-step
              v-for="(item, index) in outboundProcessStep"
              :key="index"
              :title="item.name"
              @click.native="chegeFlowPath(item.uri,index)"
            />
          </el-steps>
        </el-row>
        <div v-if="showSwitchBox" class="switch-box">
          <create-order
            v-show="nowFlowPath === flowPath.ORDER_CREATE_NODE"
            ref="createOrderEl"
            :is-detail="isDetail"
            :form-data="form.configOrderCreate"
          />
          <order-review
            v-show="nowFlowPath === flowPath.ORDER_AUDIT_NODE"
            ref="orderReviewEl"
            :is-detail="isDetail"
            :form-data.sync="form.configOrderAudit"
          />
          <flat-cable
            v-show="nowFlowPath === flowPath.ORDER_WAITING_LINE_NODE"
            ref="flatCableEl"
            :is-detail="isDetail"
            :form-data="form.configOrderWaitingLine"
          />
          <create-wave
            v-show="nowFlowPath === flowPath.WAVE_CREATE_NODE"
            ref="createWaveEl"
            :is-detail="isDetail"
            :form-data="form.configWaveCreate"
          />
          <wave-distribution
            v-show="nowFlowPath === flowPath.WAVE_ALLOCATE_NODE"
            ref="waveDistributionEl"
            :is-detail="isDetail"
            :form-data="form.configWaveAllocate"
            @clearGoodsPlace="clearGoodsPlace"
          />
          <in-production
            v-show="nowFlowPath === flowPath.ORDER_IN_PRODUCTION_NODE"
            ref="inProductionEl"
            :is-detail="isDetail"
            :warehouse-id="form.warehouseId"
            :form-data="form.configOrderInProduction"
          />
          <shipping
            v-show="nowFlowPath === flowPath.ORDER_DISPATCHING_NODE"
            ref="shippingEl"
            :is-detail="isDetail"
            :form-data="form.configOrderDispatching"
            :warehouse-code="form.warehouseCode"
          />
        </div>
        <el-form-item class="btn-boxs">
          <el-button
            v-if="!isDetail"
            :loading="loading.submit"
            type="primary"
            @click="onSubmit"
          >
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </list-block>
    <select-dialog
      ref="dialogSelect"
      :warehouse-code="form.warehouseCode"
      :order-type="form.orderType"
      @onSuccess="handleIds"
    />
  </div>
</template>

<script>
/* eslint-disable */
import ListBlock from '@/components/ListBlock/index.vue';
import { getDictionary } from '@/utils/Dictionary';

import { getWarehouseList, temporaryStorehouse } from '@/api/warehouse';
import {
  ruleDeliverFlowSearchByIdNew, ruleDeliverFlowSaveAdd,
  getTaskByNode, geIsDefaultOutFlow,
} from '@/api/configure/outboundProcess';
import loadingMixin from '@thales/loading';
import { WUJIE_EVENT_NAME } from '@/utils/subWujie/event';
import createOrder from './components/createOrder.vue';
import orderReview from './components/orderReview.vue';
import flatCable from './components/flatCable.vue';
import createWave from './components/createWave.vue';
import waveDistribution from './components/waveDistribution.vue';
import inProduction from './components/inProduction.vue';
import shipping from './components/shipping.vue';
import SelectDialog from '../components/SelectDialog.vue';
import {
  PAGE_TYPE, flowPath, outboundProcessStep,
} from '../constant';

export default {
  provide() {
    return {
      activedSteps: () => this.getActivedSteps,
      stepActive: () => this.stepActive,
      systemTableData: () => this.getSystemTableData(),
      getNodeTableData: (nodeType) => this.getNodeTableData(nodeType),
      taskAllTableData: () => this.taskAllTableData,
      isDetail: this.isDetail,
    };
  },
  components: {
    ListBlock,
    createOrder,
    orderReview,
    flatCable,
    createWave,
    waveDistribution,
    inProduction,
    shipping,
    SelectDialog,
  },
  mixins: [loadingMixin],
  data() {
    return {
      flowPath,
      outboundProcessStep,
      stepActive: 0,
      showSwitchBox: false,
      warehouseList: [],
      deliverTypeOptions: [],
      form: {
        ruleCode: '', // 流程编码
        description: '', // 流程描述
        orderType: '', // 订单类型code
        warehouseCode: '', // 仓库code
        isDefault: false, // 是否设为默认流程
        shippers: {
          infos: [],
        }, // 货主
        // 流程数据
        configOrderCreate: {
          executeMaxTime: 0,
          timeUnit: 'HOURS',
          useTransportationInventory: false, // 是否可预占在途库存
          autoFillFixLineCode: true, // 是否自动填充固定线路
          ruleFlowTaskItemDetails: [],
        },
        configOrderAudit: {
          executeMaxTime: 0,
          timeUnit: 'HOURS',
          acceptOrderAudit: 'ENABLED',
          useGoodsQuality: 'GOOD',
        },
        configOrderWaitingLine: {
          executeMaxTime: 0,
          timeUnit: 'HOURS',
          temporaryStorehouse: '',
        },
        configWaveCreate: {
          waveGroupType: ['SHIPPER'],
          executeMaxTime: 0,
          timeUnit: 'HOURS',
        },
        configWaveAllocate: {
          validatorDueOutDay: true,
          useGatherGoodsPlace: false,
          autoWaveAllocate: false, // 自动下发
          intervalTimeGatherGoodsPlace: undefined,
          executeMaxTime: 0,
          timeUnit: 'HOURS',
          ignoreAppointBatchNoWarning: false, // 允出期外货品下发推送
        },
        configOrderInProduction: {
          temporaryStorehouse: '',
          executeMaxTime: 0,
          printStationTag: false,
          timeUnit: 'HOURS',
          ruleVoiceConfig: null,
        },
        configOrderDispatching: {
          needSealLabel_status: undefined,
          returnStatus: undefined,
          returnTemporaryStorehouse: '',
          executeMaxTime: 0,
          timeUnit: 'HOURS',
        },
      },
      goodsQualityList: [],
      nowFlowPath: outboundProcessStep[0].uri,
      loading: {
        ruleDeliverFlowSearchById: false,
        submit: false,
      },
      rules: {
        ruleCode: [
          { required: true, message: '请输入流程编码', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入流程描述', trigger: 'blur' },
        ],
        orderType: [
          { required: true, message: '请选择订单类型', trigger: 'change' },
        ],
        warehouseCode: [
          { required: true, message: '请选择仓库', trigger: 'change' },
        ],
        'shippers.infos': [
          { required: true, message: '请选择货主', trigger: 'change' },
        ],
      },
      taskAllTableData: [],
    };
  },
  created() {
    this.init();
  },
  computed: {
    getActivedSteps() {
      return outboundProcessStep.slice(0, this.stepActive + 1);
    },
    isDetail() {
      return this.$route.query.type === PAGE_TYPE.VIEW;
    },
  },
  methods: {
    // 初始化获取数据
    async init() {
      this.getDictionary();
      // 获取仓库下拉列表
      this.getWarehouseList();
      this.getAllTaskData();
      if (this.$route.query.type && this.$route.query.id) {
        await this.ruleDeliverFlowSearchById();
      }
    },
    getDictionary() {
      const deliverType = getDictionary(this.$store.state.dictionary.dictionaryCodeEN.DELIVER_ORDER_TYPE_CODE);
      this.deliverTypeOptions = deliverType;
    },
    async getWarehouseList() {
      const warehouseList = await getWarehouseList({}, {
        page: 1,
        size: 9999,
      });
      this.warehouseList = warehouseList.records;
    },
    async getAllTaskData() {
      const res = await getTaskByNode({});
      this.taskAllTableData = res;
      this.showSwitchBox = true;
    },
    // 根据id获取
    async ruleDeliverFlowSearchById() {
      const res = await ruleDeliverFlowSearchByIdNew({ id: this.$route.query.id });
      res.configOrderAudit.useGoodsQuality = res.configOrderAudit.goodsQuality[0];
      const needSealLabel_status = res.configOrderDispatching.needSealLabel.status;
      if (needSealLabel_status) {
        res.configOrderDispatching.needSealLabel_status = needSealLabel_status;
      }
      if (!res.shippers) {
        res.shippers = {
          infos: [],
        };
      }
      this.form = {...res };
      this.form.updateTime = null;
      // 复制
      if (Number(this.$route.query.num) === 2) {
        this.form.ruleCode = '';
        this.form.description = '';
        this.form.orderType = '';
        this.form.warehouseCode = '';
        this.form.isDefault = false;
        this.form.shippers.infos = [];
        this.form.id = '';
        // 和仓库相关数据清空
        this.form.configOrderInProduction.temporaryStorehouse = '';
        this.form.configOrderDispatching.returnTemporaryStorehouse = '';
      }
    },
    clearGoodsPlace() {
      this.form.configWaveAllocate.intervalTimeGatherGoodsPlace = undefined;
    },
    // 改变出库流程配置
    chegeFlowPath(data, index) {
      this.stepActive = index;
      this.nowFlowPath = data;
      const getTableDataMap = this.getNodeToEl();
      getTableDataMap[this.nowFlowPath].resetTaskOptions();
    },
    // 进行表单及表格数据验证
    formValidation() {
      return new Promise(async (resolve) => {
        try {
          await this.$refs.form.validate();
          const createOrderTable = await this.$refs.createOrderEl.validateForm();
          const orderReviewTable = await this.$refs.orderReviewEl.validateForm();
          const flatCableTable = await this.$refs.flatCableEl.validateForm();
          const createWaveTable = await this.$refs.createWaveEl.validateForm();
          const waveDisbTable = await this.$refs.waveDistributionEl.validateForm();
          const inProductionTable = await this.$refs.inProductionEl.validateForm();
          const shippingTable = await this.$refs.shippingEl.validateForm();
          // console.log(inProductionTable);
          resolve({
            createOrderTable,
            orderReviewTable,
            flatCableTable,
            createWaveTable,
            waveDisbTable,
            inProductionTable,
            shippingTable,
          });
        } catch (error) {}
      });
    },
    getSubmitData(tableDatas) {
      this.form.configOrderCreate.ruleFlowTaskItemDetails = tableDatas.createOrderTable;

      this.form.configOrderAudit.ruleFlowTaskItemDetails = tableDatas.orderReviewTable;
      this.form.configOrderAudit.goodsQuality = [this.form.configOrderAudit.useGoodsQuality];

      this.form.configOrderWaitingLine.ruleFlowTaskItemDetails = tableDatas.flatCableTable;
      this.form.configWaveCreate.ruleFlowTaskItemDetails = tableDatas.createWaveTable;
      this.form.configWaveAllocate.ruleFlowTaskItemDetails = tableDatas.waveDisbTable;
      this.form.configOrderInProduction.ruleFlowTaskItemDetails = tableDatas.inProductionTable;

      this.form.configOrderDispatching.ruleFlowTaskItemDetails = tableDatas.shippingTable;
      this.form.configOrderDispatching.needSealLabel = {
        status: this.form.configOrderDispatching.needSealLabel_status,
      };
      // console.log(this.form);
    },
    async onSubmit() {
      const tableDatas = await this.formValidation();
      if (this.form.isDefault) {
        this.checkIsDefault(tableDatas);
      } else {
        this.ruleDeliverFlowSaveAdd(tableDatas);
      }
    },
    // 提交前校验是否已经是默认流程
    async checkIsDefault(tableDatas) {
      const res = await geIsDefaultOutFlow({
        warehouseCode: this.form.warehouseCode,
        deliverType: this.form.orderType,
      });
      if (res.ruleId && res.ruleId != this.$route.query.id) {
        await this.$confirm(`${res.ruleCode}+${res.description}，已经设为默认，是否替换原默认流程`);
        this.ruleDeliverFlowSaveAdd(tableDatas);
      } else {
        this.ruleDeliverFlowSaveAdd(tableDatas);
      }
    },
    async ruleDeliverFlowSaveAdd(tableDatas) {
      this.getSubmitData(tableDatas);
      // console.log(this.form);
      this.loading.submit = true;
      if (this.$route.query.num == 2) { // 赋值等同于新增，删除租户信息
        this.form.tenantId = '';
        this.form.tenantName = '';
      }
      try {
        await ruleDeliverFlowSaveAdd({ ...this.form });
        this.$message.success('保存成功！');
        this.loading.submit = false;
        setTimeout(() => {
          const routeUrl = this.$router.resolve({
            path: '/cloudWarehouse/processConfig',
          });
          if (window.$wujie) {
            window.$wujie.bus.$emit(WUJIE_EVENT_NAME.CLOSE_MAIN_ROUTE, this.$route.path);

            window.$wujie.bus.$emit(WUJIE_EVENT_NAME.SUB_ROUTE_CHANGE, {
              path: routeUrl.route.fullPath,
            });
          } else {
            window.close();
          }
        }, 1000);
      } catch (error) {
        this.loading.submit = false;
      }
    },
    handleSelect(val) {
      this.form.warehouseId = this.warehouseList.filter((i) => i.warehouseCode === val)[0].id;

      this.form.shippers.infos = [];
    },
    handleEdit() {
      if (this.form.warehouseCode && this.form.orderType) {
        const customersInfo = this.form.shippers.infos || [];
        this.$refs.dialogSelect.init(customersInfo, this.isDetail, 1);
      } else {
        this.$message({
          message: '请选择订单类型及仓库',
          type: 'warning',
        });
      }
    },
    handleIds(customerInfos) {
      this.form.shippers.infos = customerInfos;
    },
    // 获取所有已经添加了的系统任务，新增任务时系统任务不可重复添加，需将已添加的任务禁用
    getSystemTableData() {
      const createOrderTable = this.$refs.createOrderEl.getPureTableData();
      const orderReviewTable = this.$refs.orderReviewEl.getPureTableData();
      const flatCableTable = this.$refs.flatCableEl.getPureTableData();
      const createWaveTable = this.$refs.createWaveEl.getPureTableData();
      const waveDisbTable = this.$refs.waveDistributionEl.getPureTableData();
      const inProductionTable = this.$refs.inProductionEl.getPureTableData();
      const shippingTable = this.$refs.shippingEl.getPureTableData();
      const allTableData = [
        ...createOrderTable,
        ...orderReviewTable,
        ...flatCableTable,
        ...createWaveTable,
        ...waveDisbTable,
        ...inProductionTable,
        ...shippingTable,
      ];
      return allTableData.filter((i) => i.isSystem);
    },
    // 获取指定节点的任务
    getNodeTableData(nodeType) {
      if (!nodeType) return [];
      const getTableDataMap = this.getNodeToEl();
      return getTableDataMap[nodeType].getPureTableData();
    },
    getNodeToEl() {
      return {
        'ORDER_CREATE_NODE': this.$refs.createOrderEl,
        'ORDER_AUDIT_NODE': this.$refs.orderReviewEl,
        'ORDER_WAITING_LINE_NODE': this.$refs.flatCableEl,
        'WAVE_CREATE_NODE': this.$refs.createWaveEl,
        'WAVE_ALLOCATE_NODE': this.$refs.waveDistributionEl,
        'ORDER_IN_PRODUCTION_NODE': this.$refs.inProductionEl,
        'ORDER_DISPATCHING_NODE': this.$refs.shippingEl,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  padding: 15px;
}
::v-deep .el-col {
  display:flex;
  justify-content:left;
  align-items:center;
}
.time-interval{
  width: 50px;
}
.wash-box .wash-box-in{
  margin-bottom:5px;
  ::v-deep .el-input{
    width: 120px;
  }
}
.btn-boxs{
  margin-top: 30px;
}
.explain{
  color:#F59A23;
}
.special-color{
  color: #FF0000;
 ::v-deep .el-checkbox__label{
    color: #FF0000;
  }
}
.switch-box{
  width: 100%;
  min-height:500px;
  margin-top: 24px;
  box-shadow: 0 2px 7px 0 rgb(0 25 55 / 10%);
  border-radius: 10px;
}
.el-steps  ::v-deep .el-step.is-horizontal:hover {
  cursor: pointer;
  .el-step__head{
    color: #2AD09C;
    border-color: #2AD09C;
  }
  .el-step__main{
    .el-step__title{
      color: #2AD09C;
    }

  }
}
.el-steps ::v-deep{
        .el-step__head {
            width: 96%;
        }
         .el-step__icon.is-text {
            width: 32px;
            height: 32px;
        }
        .el-step.is-horizontal .el-step__line {
            top: 16px;
        }
        .el-step__head.is-process {
            border-color: #06B880;
        }
        .el-step__head.is-process .el-step__icon.is-text {
            color: #fff;
            background-color: #06B880;
        }
        .el-step__title.is-success{
              color: #606266;
        }
  .el-step {
    .el-step__main {
            position: absolute;
            left: 24px;
            top: 2px;
            height: 26px;
            line-height: 26px;
            background-color: #fff;
            padding: 0 10px 0 16px;
        }
        .el-step__title {
            line-height: 26px;
        }
  }
}
</style>
